import './MapLineMarker.less';
import { Line } from '../../../models/Geometries';
import { Layer, Source } from 'react-map-gl';

interface Props {
  line: Line;
  hovered: boolean;
  isSync?: boolean;
}

function MapLineMarker({ line, hovered, isSync }: Props) {

  /*
    Se incluye la variable isSync para diferenciar si se selecciono 
    una geometria sincronizada o no, y asi hacer el dispatch en el redux y poder mostrar el
    modal correspondiente, ya que las lineas y poligonos no tienen un onClick predeterminado
    se debe de manejar un string unico para asi diferenciarlos en el componente padre y asignarles
    un Onclick.
  */

  return (
    <Source id={'LineSource-' + line.id}
            type='geojson' data={{
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [...line.puntos.map(p => [p.longitud, p.latitud])],
      },
      properties: {},
    }}>
      <Layer id={isSync ? 'sync_line-'+line.id : 'line-'+line.id} type={'line'} paint={{
        'line-color': line.color,
        'line-width': hovered ? 4 : 2,
      }} beforeId={'order-line'}
      />
      <Layer id={isSync ? 'sync_line_click_area-'+line.id : 'line_click_area-'+line.id} type={'line'} paint={{
        'line-color': 'rgba(0,0,0,0)',
        'line-width': 12,
      }} beforeId={'order-line'}
      />
    </Source>
  );
}

export default MapLineMarker;
